import { makeStyles, typographyStyles } from "@fluentui/react-components";

export const useHelpMessageStyles = makeStyles({
  flexColumnStyle: {
    display: "flex",
    flexDirection: "column",
  },
  flexCentered: {
    justifyContent: "center",
    justifyItems: "center",
    alignItems: "center",
  },
  textUpperCase: {
    textTransform: "uppercase",
  },
  fullWidth: {
    width: "100%",
  },
  footNoteContainer: {
    marginTop: "15px",
  },
  footNote: typographyStyles.caption1,
});
